import React, { useState, useCallback } from 'react'
import { I18n } from 'react-redux-i18n'
import { useHistory } from 'react-router-dom'
import './styles.scss'

import IntegrationAppAPI from 'api/integrationApp'
import ContainerPage from 'components/common/ContainerPage'
import InputText from 'components/forms/InputText'
import Textarea from 'components/forms/Textarea'
import Button from 'components/forms/Button'

const APPCreate = () => {
  const history = useHistory()

  const [state, setState] = useState({ name: '', description: '' })
  const [errors, setErrors] = useState({ name: '' })
  const [inProgress, setInProgress] = useState(false)

  const onSubmit = useCallback(
    async (target, state) => {
      try {
        setInProgress(true)

        const appId = await IntegrationAppAPI.create(state)

        setInProgress(false)

        history.push(`/dashboard/integrations/apps/${appId}`)
      } catch(error) {
        if (error?.field === 'name') {
          setErrors(state => ({
            ...state,
            name: I18n.t(error.type)
          }))

          target.name.focus()
        }

        setInProgress(false)
      }
    }, []
  )

  return (
    <ContainerPage
      displayBeta
      title={I18n.t('nav_integrations_api_app')}
    >
      <div className='integrations-app-container'>
        <div className='integrations-app-create'>
          <div className='integrations-app-create__title'>
            {I18n.t('integration_app_create_title')}
          </div>

          <form
            className='integrations-app-create__form'
            onSubmit={(e) => {
              e.preventDefault()

              onSubmit(e.target, state)
            }}
          >
            <InputText
              title={I18n.t('integration_app_name')}
              htmlFor='name'
              value={state.name}
              onChange={(text) => {
                setState({ ...state, name: text })

                if (errors.name) setErrors({ ...errors, name: '' })
              }}
              minLength={5}
              required
              error={errors.name}
            />

            <Textarea
              title={I18n.t('integration_app_description')}
              htmlFor='description'
              value={state.description}
              onChange={(text) => {
                setState({ ...state, description: text })
              }}
              minLength={5}
              required
            />

            <div className='integrations-app-create__form-buttons'>
              <Button
                label={I18n.t('dashboard_cancel')}
                color='secondary'
                disabled={inProgress}
                onClick={() => history.push('/dashboard/integrations/apps')}
              />
              <Button
                label={I18n.t('dashboard_save')}
                className='integrations-app-create__form-buttons-save'
                disabled={inProgress}
                type='submit'
              />
            </div>
          </form>
        </div>
      </div>
    </ContainerPage>
  )
}

export default APPCreate
